import React, { Component, PropTypes } from 'react';
import { assign } from 'lodash';
import Auth0WebHeader from '@auth0/web-header';
import ContactForm from 'auth0-contact-form';
import loggedin from 'modules/loggedin';
import { login } from 'modules/boot/sso';

class Header extends Component {
  static propTypes = {
    theme: PropTypes.string,
    featuredLink: PropTypes.string,
    featuredTitle: PropTypes.string,
    featuredDescription: PropTypes.string,
    featuredCTA: PropTypes.string,
    featuredIconColor: PropTypes.string,
    talkToSalesButtonText: PropTypes.string
  };

  static checkThemeFromHTMLClass = () => {
    const html = document.documentElement;
    const htmlHasClass = className => html.classList.contains(className);
    const isDarkTheme = htmlHasClass('header-dark') || htmlHasClass('theme-dark');

    return isDarkTheme ? 'dark' : 'light';
  };

  state = {
    logged: false,
    theme: 'dark',
    showLock: () => {},
    showContactForm: () => {}
  };

  componentDidMount() {
    /* eslint-env browser */

    this.createContactForm();

    this.setState({
      login,
      signup: () => window.signup(),
      showContactForm: () => this.contactForm.show({ includePhoneField: true })
    });

    loggedin.onChange(logged => {
      if (document.getElementsByClassName('login-link').length) {
        return;
      }

      this.setState({ logged });
    });
  }

  createContactForm() {
    /* eslint-env browser */

    const jQuery = window.jQuery;
    const metricsLib = window.metricsLib;
    const extendedOptions = window.APP_STATE.contactFormOptions;

    const contactFormOptions = {
      onModalOpen() {
        metricsLib.track('open:talk-to-sales');
      },
      onFormSuccess(metricsData) {
        metricsLib.track('register:lead:talk-to-sales-modal', metricsData);
        metricsLib.track('sent:talk-to-sales', metricsData);
      },
      onFormFail(metricsData) {
        metricsLib.track('fail:register:lead:talk-to-sales-modal', metricsData);
        metricsLib.track('fail-sent:talk-to-sales', metricsData);
      }
    };
    this.contactForm = new ContactForm(assign({}, contactFormOptions, extendedOptions));
  }

  render() {
    const { logged, login, signup, showContactForm } = this.state;
    const {
      featuredLink,
      featuredTitle,
      featuredDescription,
      featuredCTA,
      featuredIconColor,
      talkToSalesButtonText
    } = this.props;
    const theme = this.props.theme || this.state.theme;
    const HeaderProps = {
      logged,
      theme,
      login,
      signup,
      showContactForm,
      featuredLink,
      featuredTitle,
      featuredDescription,
      featuredCTA,
      featuredIconColor,
      talkToSalesButtonText
    };
    const Auth0WebHeaderProps = toAuth0WebHeaderProps(HeaderProps);

    return <Auth0WebHeader {...Auth0WebHeaderProps} />;
  }
}

function toAuth0WebHeaderProps(props) {
  const Auth0WebHeaderProps = {
    theme: props.theme,
    talkToSalesButtonLink: null,
    talkToSalesButtonOnClick: props.showContactForm,
    className: 'site-header-v2',
    loginButtonOnClick: props.login,
    featuredLink: props.featuredLink,
    featuredTitle: props.featuredTitle,
    featuredDescription: props.featuredDescription,
    featuredCTA: props.featuredCTA,
    featuredIconColor: props.featuredIconColor,
    talkToSalesButtonText: props.talkToSalesButtonText
  };

  if (props.logged) {
    Auth0WebHeaderProps.signupButtonLink = 'https://manage.auth0.com';
  } else {
    Auth0WebHeaderProps.signupButtonOnClick = props.signup;
  }

  return Auth0WebHeaderProps;
}

export default Header;



// WEBPACK FOOTER //
// ./src/modules/header/Header.js